export const paymentSituationMap: Record<string, string> = {
  PENDING: "Pendente",
  PAYMENT_CREATED: "Cobrança criada",
  PAYMENT_AWAITING_RISK_ANALYSIS: "Aguardando análise de risco",
  PAYMENT_APPROVED_BY_RISK_ANALYSIS: "Aprovado pela análise de risco",
  PAYMENT_REPROVED_BY_RISK_ANALYSIS: "Reprovado pela análise de risco",
  PAYMENT_AUTHORIZED: "Autorizado (aguardando captura)",
  PAYMENT_UPDATED: "Cobrança atualizada",
  PAYMENT_CONFIRMED: "Pagamento confirmado (saldo pendente)",
  PAYMENT_RECEIVED: "Pagamento recebido",
  PAYMENT_CREDIT_CARD_CAPTURE_REFUSED: "Falha na captura do cartão",
  PAYMENT_ANTICIPATED: "Pagamento antecipado",
  PAYMENT_OVERDUE: "Pagamento vencido",
  PAYMENT_DELETED: "Cobrança removida",
  PAYMENT_RESTORED: "Cobrança restaurada",
  PAYMENT_REFUNDED: "Estornado",
  PAYMENT_PARTIALLY_REFUNDED: "Estornado parcialmente",
  PAYMENT_REFUND_IN_PROGRESS: "Estorno em andamento",
  PAYMENT_RECEIVED_IN_CASH_UNDONE: "Recebimento em dinheiro desfeito",
  PAYMENT_CHARGEBACK_REQUESTED: "Chargeback solicitado",
  PAYMENT_CHARGEBACK_DISPUTE: "Em disputa de chargeback",
  PAYMENT_AWAITING_CHARGEBACK_REVERSAL: "Chargeback vencido, aguardando repasse",
  PAYMENT_DUNNING_RECEIVED: "Recebimento por negativação",
  PAYMENT_DUNNING_REQUESTED: "Negativação solicitada",
  PAYMENT_BANK_SLIP_VIEWED: "Boleto visualizado",
  PAYMENT_CHECKOUT_VIEWED: "Fatura visualizada",
  PAYMENT_SPLIT_CANCELLED: "Split cancelado",
  PAYMENT_SPLIT_DIVERGENCE_BLOCK: "Bloqueado por divergência de split",
  PAYMENT_SPLIT_DIVERGENCE_BLOCK_FINISHED: "Bloqueio por split finalizado",
};
